import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { createPortal } from 'react-dom';
import './MessageModal.css';

class MessageModal extends Component {
  // 提示訊息模態框
  static alert(message, onOk) {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const defaultClose = () => {
      root.unmount();
      document.body.removeChild(container);
    };

    const handleOk = () => {
      root.unmount();
      document.body.removeChild(container);
      if (onOk) onOk();
    };

    root.render(
      <MessageModal
        type="alert"
        message={message}
        onOk={onOk ? handleOk : defaultClose}
        showOk={true}
      />
    );
  }

  // 帶有確認和取消按鈕的模態框
  static confirm(message, onOk, onClose) {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleClose = () => {
      root.unmount();
      document.body.removeChild(container);
      if (onClose) onClose();
    };

    const handleOk = () => {
      root.unmount();
      document.body.removeChild(container);
      if (onOk) onOk();
    };

    root.render(
      <MessageModal
        type="confirm"
        message={message}
        onOk={handleOk}
        onClose={handleClose}
        showOk={true}
        showClose={true}
      />
    );
  }

  render() {
    const { type, message, onOk, onClose, showOk, showClose } = this.props;
    if (type === 'alert') {
      return createPortal(
        <div className="modal">
          <div className="alert-modal-content" onClick={e => e.stopPropagation()}>
            <div>
              <p>{message}</p>
              {showOk && (
                <button className="btn ok-button" onClick={onOk}>確認</button>
              )}
            </div>
          </div>
        </div>,
        document.body
      );
    } else if (type === 'confirm') {
      return createPortal(
        <div className="modal">
          <div className="confirm-modal-content" onClick={e => e.stopPropagation()}>
            <p>{message}</p>
            <div className="confirm-buttons-container">
              {showOk && (
                <button className="btn ok-button" onClick={onOk}>確認</button>
              )}
              {showClose && (
                <button className="btn cancel-button" onClick={onClose}>取消</button>
              )}
            </div>
          </div>
        </div>,
        document.body
      );
    }
  }
}

export default MessageModal;
